import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { toast } from "sonner";
import { formatApiError } from "@/utils/format";

const showError = toast.error;
toast.error = (message, options) => showError(formatApiError(message), options);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
